import React, { useEffect, useRef, useState } from 'react';

const AnimatedSection = ({ children, className = '', animation = 'fadeInUp', delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [delay]);

  const animations = {
    fadeInUp: isVisible
      ? 'opacity-100 translate-y-0'
      : 'opacity-0 translate-y-12',
    fadeIn: isVisible ? 'opacity-100' : 'opacity-0',
    scaleIn: isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95',
    slideInLeft: isVisible
      ? 'opacity-100 translate-x-0'
      : 'opacity-0 -translate-x-12',
    slideInRight: isVisible
      ? 'opacity-100 translate-x-0'
      : 'opacity-0 translate-x-12'
  };

  return (
    <div
      ref={sectionRef}
      className={`transition-all duration-700 ease-out ${animations[animation]} ${className}`}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;